// extracted by mini-css-extract-plugin
export default {"container":"_3jMCAP9T","title":"JVc8lbzx","buttonContainer":"_39UqxmdW","error":"_33QdK4pv"};